import * as React from 'react';

const ExclamationMarkIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="19"
    fill="none"
    viewBox="0 0 8 19"
    {...props}
  >
    <path
      fill="#F0567A"
      d="m7.771.318-2.521 12.5H1.237L2.835.318zM2.445 18.784q-1.04 0-1.696-.719-.648-.727-.542-1.767.106-1.011.915-1.73.817-.72 1.855-.72.986 0 1.643.72.666.719.559 1.73a2.53 2.53 0 0 1-.488 1.26q-.41.56-1.012.898a2.5 2.5 0 0 1-1.234.328"
    ></path>
  </svg>
);

export default ExclamationMarkIcon;
